// allow access to the performance section of the account page.
export const PERFORMANCE_PAGE_SPLIT = 'performance-page';

// enable the dashboard to check for unacknowledged strikes
export const DASHBOARD_STRIKE_CHECK = 'dashboard-strike-check-policy';

// enable the edit timestamps reasons modal to pop up while editing timestamp
export const EDIT_TIMESTAMP_REASONS_SPLIT = 'Edit-Timestamp-Reasons-Modal';

export const COMMUTE_PLANNING_SPLIT = 'commute-planning';

export const UI_REFRESH = 'ui-refresh';

export const CMB_GENERATE_NEW_HIRE_DOCUMENTS_API = 'cmb-generate-new-hire-documents';
